module.exports = __webpack_public_path__ + "img/logo-company.002a2d6e.png";